/**
 * The type of (redux) action which sets the audio settings.
 */
export const SET_AUDIO_SETTINGS = 'SET_AUDIO_SETTINGS';
/**
 * The type of (redux) action which sets the preview audio track settings.
 */
export const SET_PREVIEW_AUDIO_TRACK = 'SET_PREVIEW_AUDIO_TRACK';
/**
 * The type of (redux) action which sets the visibility of the audio settings popup.
 */
export const SET_AUDIO_SETTINGS_VISIBILITY = 'SET_AUDIO_SETTINGS_VISIBILITY';
/**
 * The type of (redux) action which sets the visibility of the video settings popup.
 */
export const SET_VIDEO_SETTINGS_VISIBILITY = 'SET_VIDEO_SETTINGS_VISIBILITY';
